import React from 'react';
import { Row } from '@fiverr-private/briefs_table';
import { Link, Typography } from '@fiverr-private/typography';
import { BriefDisplayStatus } from '@fiverr-private/dynamic_matching';
import { BriefItem } from '../../../../../../lib/types/brief';
import { isCurrentUser } from '../../../../../../lib/utils/getters';
import { useInitialProps } from '../../../../../context';
import { getAgenticViewPageUrl, getManagementPageUrl } from '../../../../shared/const';
import { reportBriefCardClick } from '../../../../shared/bqEvents';
import { useBriefDrawer } from '../../../useBriefDrawer';

interface BriefTitleProps {
  row: Row<BriefItem>;
}

export const BriefTitle: React.FC<BriefTitleProps> = ({ row }: BriefTitleProps) => {
  const { currency } = useInitialProps();
  const BriefDrawer = useBriefDrawer();
  const isUserOwner = isCurrentUser(row.original.createdBy.id);
  const isRejectedStatus = row.original.briefDisplayStatus === BriefDisplayStatus.REJECTED;

  const url = getManagementPageUrl(row.original.id);

  const sendBiEvent = () => reportBriefCardClick('brief_title', row.original);

  if (row.original.type === 'agentic') {
    // No preview drawer exists for agentic briefs and their view page is owner-gated,
    // so non-owners get plain text.
    if (!isUserOwner) {
      return (
        <Typography fontWeight="semibold" onClick={sendBiEvent}>
          {row.original.title}
        </Typography>
      );
    }

    return (
      <Link
        decoration={{ hover: 'underline' }}
        href={getAgenticViewPageUrl(row.original.id)}
        fontWeight="semibold"
        onClick={sendBiEvent}
      >
        {row.original.title}
      </Link>
    );
  }

  if (!isUserOwner || isRejectedStatus) {
    return (
      <BriefDrawer currency={currency} briefId={row.original.id} key={row.original.id} hideFooter>
        <Typography decoration={{ hover: 'underline' }} cursor="pointer" fontWeight="semibold" onClick={sendBiEvent}>
          {row.original.title}
        </Typography>
      </BriefDrawer>
    );
  }

  return (
    <Link decoration={{ hover: 'underline' }} href={url} fontWeight="semibold" onClick={sendBiEvent}>
      {row.original.title}
    </Link>
  );
};
